import React from "react";

import HeroSection from "./HeroSection"
import Content from "./Content";
import { Eurofox } from "./Eurofox";
import Launchcampaign from "./Launchcampaign";
import Technology from "./Technology";
import { Euro } from "lucide-react";
import Eurof from "./Eurof";

// import { Flowingsms }  from "./Flowingsms";

function Home() {
  return (
    <div>

      <div>
        <HeroSection />
      </div>
      {/* website content */}
      <div>
        <Content />
      </div>
      <div>
        <Eurofox />
      </div>
      <div>
        <Launchcampaign/>
      </div>
        <div>
        <Eurof/>
      </div>
         <div>
        <Technology/>
      </div>
    </div>
  );
}

export default Home;
